'use strict';

cartDraft.$inject = ["Product"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartDraft = cartDraft;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartDraft(Product) {
    var clazz = function CartDraft() {
        var defaults = {
            products: [],
            vatList: [],
            numberOfProducts: 0,
            totalPriceWithoutDiscount: 0,
            totalDiscount: 0,
            totalPriceWithDiscount: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {

        addProduct: function addProduct(product) {
            // when the product is already in the cart, then just update the quantity
            var productInList = _lodash2.default.find(this.products, { id: product.id });
            if (!productInList) {
                product.isInCart = true;
                this.products.push(product);
                this.updateTotals();
            } else {
                var newQuantity = productInList.quantity + product.quantity;
                this.changeQuantity(product.id, newQuantity);
            }
        },

        removeProduct: function removeProduct(productId) {
            _lodash2.default.remove(this.products, { id: productId });
            this.updateTotals();
        },

        updateTotals: function updateTotals() {
            var product = null;
            var numberOfProducts = 0;
            var totalPriceWithoutDiscount = 0;
            var totalDiscount = 0;
            var totalPriceWithDiscount = 0;

            for (var i = 0; i < this.products.length; i++) {
                product = this.products[i];
                numberOfProducts += product.quantity;
                totalPriceWithoutDiscount += product.totalPriceWithoutDiscount;
                totalDiscount += product.totalDiscount;
                totalPriceWithDiscount += product.totalPriceWithDiscount;
            }

            this.numberOfProducts = numberOfProducts;
            this.totalPriceWithoutDiscount = totalPriceWithoutDiscount;
            this.totalDiscount = totalDiscount;
            this.totalPriceWithDiscount = totalPriceWithDiscount;
            this.vatList = this.getVatList();
        },

        getVatList: function getVatList() {
            var vatList = [];
            var thisCart = this;

            angular.forEach(this.products, function (p) {
                thisCart.addVat(vatList, p);
            });

            return vatList;
        },

        addVat: function addVat(vatList, product) {
            var vat = product.tax;
            var vatItem = _lodash2.default.find(vatList, { 'pct': vat });
            var vatAmount = product.totalPriceWithoutDiscount * vat / 100;
            if (!vatItem) {
                vatList.push({ 'pct': vat, 'amount': vatAmount });
            } else {
                vatItem.amount += vatAmount;
            }
        },

        changeQuantity: function changeQuantity(productId, quantity) {
            var product = _lodash2.default.find(this.products, { id: productId });
            if (!product) {
                return;
            }

            product.quantity = quantity;
            product.updateTotals();
            this.updateTotals();
        }
    });

    clazz.create = function (resource) {
        var cart = new clazz();

        cart.products = [];
        angular.forEach(resource.products, function (productResource) {
            var product = Product.getClass().createFromLocalStorage(productResource, null, null, productResource.type, false);
            cart.products.push(product);
        });

        cart.numberOfProducts = resource.numberOfProducts;
        cart.totalPriceWithoutDiscount = resource.totalPriceWithoutDiscount;
        cart.totalDiscount = resource.totalDiscount;
        cart.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        cart.vatList = cart.getVatList();

        return cart;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/cartDraftModel.js
// module id = 731
// module chunks = 0